import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("auto-footer")
export class AutoFooter extends LitElement {
  render() {
    return html` &copy; 2026 Jan Kos `;
  }
}
